// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__HUbx5","spin":"styles_spin__Rb1qh","spinnerWalky":"styles_spinnerWalky__QPzX-"};